import { useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import PropTypes from 'prop-types';
import ThemeToggle from '@/shared/components/templates/ThemeToggle.jsx';
import Logo from '@/shared/components/modules/Logo.jsx';
import lightLogo from '@/assets/images/Logo.png';
import whiteLogo from '@/assets/images/WhiteLogo.png';
import CreditQuickAccess from '@/feature/Billing/components/CreditQuickAccess.jsx';

export default function MobileHeader({ onMenuClick }) {
  const navigate = useNavigate();

  return (
    <header className="shadow-tertiary-6 fixed top-0 right-0 left-0 z-50 bg-white backdrop-blur-xl transition-all duration-300 dark:bg-gray-800 dark:shadow-lg">
      {/* Safe area spacer — this div sits behind the notch and inherits the header background */}
      <div
        style={{
          height: 'env(safe-area-inset-top, 0px)',
        }}
        className="w-full"
      />

      {/* Header content */}
      <div className="border-tertiary-10 flex h-16 items-center justify-between border-b px-4 dark:border-gray-700/50">
        <button
          className="bg-tertiary-6 text-tertiary-80 hover:bg-tertiary-10 active:bg-tertiary-20 rounded-xl p-2.5 transition-all duration-200 hover:scale-110 active:scale-95 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 dark:active:bg-gray-500"
          onClick={onMenuClick}
          aria-label="منو"
        >
          <Menu size={22} strokeWidth={2.5} />
        </button>

        {/* Logo */}
        <Logo
          src={lightLogo}
          darkSrc={whiteLogo}
          size="sm"
          onClick={() => navigate('/')}
          className="w-32"
        />

        {/* Actions */}
        <div className="flex items-center gap-2">
          {/* Theme Toggle */}
          <ThemeToggle />
          <CreditQuickAccess compact />
        </div>
      </div>
    </header>
  );
}

MobileHeader.propTypes = {
  onMenuClick: PropTypes.func.isRequired,
};
